/**
 * ToDo Service - API calls voor takenlijst
 */

import apiFetch from './api';

export type TodoPrioriteit = 'LAAG' | 'NORMAAL' | 'HOOG';
export type TodoStatus = 'OPEN' | 'BEZIG' | 'KLAAR';

export interface Todo {
  id: number;
  titel: string;
  omschrijving?: string;
  prioriteit: TodoPrioriteit;
  status: TodoStatus;
  toegewezen_aan?: string;
  opmerkingen?: string;
  actief: boolean;
  created_at: string;
  updated_at?: string;
}

export interface TodoCreate {
  titel: string;
  omschrijving?: string;
  prioriteit?: TodoPrioriteit;
  status?: TodoStatus;
  toegewezen_aan?: string;
  opmerkingen?: string;
}

export interface TodoUpdate {
  titel?: string;
  omschrijving?: string;
  prioriteit?: TodoPrioriteit;
  status?: TodoStatus;
  toegewezen_aan?: string;
  opmerkingen?: string;
}

class TodosService {
  private baseUrl = '/api/v1/todos';

  async getAll(status?: TodoStatus): Promise<Todo[]> {
    const url = status ? `${this.baseUrl}?status=${status}` : this.baseUrl;
    return apiFetch(url);
  }

  async getById(id: number): Promise<Todo> {
    return apiFetch(`${this.baseUrl}/${id}`);
  }

  async create(data: TodoCreate): Promise<Todo> {
    return apiFetch(this.baseUrl, {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

  async update(id: number, data: TodoUpdate): Promise<Todo> {
    return apiFetch(`${this.baseUrl}/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
  }

  async delete(id: number): Promise<void> {
    return apiFetch(`${this.baseUrl}/${id}`, {
      method: 'DELETE'
    });
  }
}

export const todosService = new TodosService();
